import { FormlyModule } from '@ngx-formly/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';

import { SnDetailedCheckboxFormField } from './components/form-field/detailed-checkbox.form-field';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    ReactiveFormsModule,
    // Material
    MatCheckboxModule,
    MatIconModule,
    // Formly
    FormlyModule.forChild({
      types: [
        {
          name: 'detailed-checkbox',
          component: SnDetailedCheckboxFormField,
        },
      ],
    }),
  ],
  exports: [MatCheckboxModule, MatIconModule],
  declarations: [SnDetailedCheckboxFormField],
})
export class SnDetailedCheckboxModule {}
